'use client';
import React, { useState } from 'react';

interface TeamMember {
  name: string;
  credential: string;
  title: string;
  bio: string;
  image: string;
  alt: string;
}

const teamMembers: TeamMember[] = [
{
  name: 'Manish Shah',
  credential: 'J.D.',
  title: 'Head of Alternatives',
  bio: 'Manish Shah leads Timber Point\'s alternatives platform, bringing extensive legal and investment expertise to the curation and oversight of alternative investment strategies. His background spans institutional investment management and financial law, providing a unique perspective on risk, compliance, and manager selection.',
  image: 'https://timberpointcapital.com/assets/images/Manish2_cropped-1776307448857.png',
  alt: 'Manish Shah, J.D. - Head of Alternatives at Timber Point Capital Management'
},
{
  name: 'David Cleary',
  credential: 'CFA',
  title: 'President & Chief Investment Officer',
  bio: 'David Cleary serves as President and Chief Investment Officer of Timber Point Capital Management. He brings over 35 years of institutional investment management experience, including his tenure as Head of Fixed Income at Lazard Asset Management where he oversaw $26 billion in assets.',
  image: 'https://timberpointcapital.com/assets/images/DCleary-1776306582656.jpg',
  alt: 'David Cleary, CFA - President & Chief Investment Officer at Timber Point Capital Management'
},
{
  name: 'Patrick Mullin',
  credential: 'CFA',
  title: 'Partner & Managing Director',
  bio: 'Patrick Mullin is a Partner and Managing Director at Timber Point Capital Management. With over 35 years of institutional portfolio management experience, Patrick brings deep expertise in multi-asset portfolio construction, risk management, and advisor partnership to the firm.',
  image: 'https://timberpointcapital.com/assets/images/PMullin-1777559512754.jpg',
  alt: 'Patrick Mullin, CFA - Partner & Managing Director at Timber Point Capital Management'
},
{
  name: 'Karol Krucinski',
  credential: 'CFA',
  title: 'Portfolio Director',
  bio: 'Karol Krucinski serves as Portfolio Director at Timber Point Capital Management. He brings institutional-grade portfolio construction expertise and quantitative analytical capabilities to the firm\'s investment process, supporting both the alternatives platform and broader portfolio management activities.',
  image: 'https://timberpointcapital.com/assets/images/Karol_FCA._clear_crop-1776348428262.jpg',
  alt: 'Karol Krucinski, CFA - Portfolio Director at Timber Point Capital Management'
},
{
  name: 'Victor A. Canto',
  credential: 'Ph.D.',
  title: 'Economic Consultant',
  bio: 'Victor A. Canto, Ph.D. serves as Economic Consultant to Timber Point Capital Management. A renowned economist and investment strategist, Dr. Canto provides macroeconomic research, market analysis, and strategic investment insights that inform the firm\'s portfolio positioning and risk management framework.',
  image: 'https://timberpointcapital.com/assets/images/victor_in_suit_crop-1776347573395.jpg',
  alt: 'Victor A. Canto, PhD - Economic Consultant at Timber Point Capital Management'
},
{
  name: 'Diane DeCaprio',
  credential: '',
  title: 'Operations Manager',
  bio: 'Diane DeCaprio serves as Operations Manager at Timber Point Capital Management. She oversees the firm\'s operational infrastructure, client service processes, and administrative functions — ensuring seamless execution across all aspects of the business and delivering exceptional service to advisor partners.',
  image: 'https://timberpointcapital.com/assets/images/Diane_Decaprio_1_275x275-1776306921920.jpg',
  alt: 'Diane DeCaprio - Operations Manager at Timber Point Capital Management'
}];


const teamStats = [
{ value: '2020', label: 'Founded' },
{ value: '20+', label: 'Years Team Working Together' },
{ value: '100+', label: 'Years Combined Experience' },
{ value: '35+', label: 'Years Institutional Portfolio Management' }];


export default function TeamSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <section id="team" className="bg-white">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-0.5" style={{ backgroundColor: '#c9a84c' }} />
          <span className="text-xs font-semibold tracking-widest uppercase" style={{ color: '#c9a84c', letterSpacing: '0.2em' }}>
            Our Team
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
          <div>
            <h2 className="font-black mb-4" style={{ color: '#1a2744', fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: '1.15', fontFamily: 'Lato, sans-serif' }}>
              OUR TEAM
            </h2>
            <p className="font-bold mb-4" style={{ color: '#4060a1', fontSize: '1.1rem' }}>
              Institutional Pedigree. Advisor-Centered Design.
            </p>
            <p className="text-base leading-relaxed" style={{ color: '#666666' }}>
              Institutional background across pensions, endowments, and UHNW. Supported by a multidisciplinary team with expertise in institutional research, portfolio construction, alternative investments, and client service.
            </p>
          </div>

          {/* Stats grid */}
          <div className="grid grid-cols-2 gap-4">
            {teamStats.map((stat, i) =>
            <div
              key={i}
              className="p-6 text-center border border-[#e0e4ec]"
              style={{ backgroundColor: '#f5f6f8' }}>
              
                <div className="text-3xl font-black mb-1" style={{ color: '#1a2744' }}>{stat.value}</div>
                <div className="text-xs uppercase tracking-wider" style={{ color: '#666', letterSpacing: '0.1em' }}>{stat.label}</div>
              </div>
            )}
          </div>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, i) =>
          <div
            key={i}
            className="group cursor-pointer"
            onClick={() => setActiveIndex(activeIndex === i ? null : i)}>
            
              {/* Photo */}
              <div className="relative overflow-hidden mb-4" style={{ aspectRatio: '1/1' }}>
                <img
                src={member.image}
                alt={member.alt}
                className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500"
                style={{ filter: 'grayscale(100%)' }}
                onMouseEnter={(e) => {(e.currentTarget as HTMLImageElement).style.filter = 'grayscale(0%)';}}
                onMouseLeave={(e) => {(e.currentTarget as HTMLImageElement).style.filter = 'grayscale(100%)';}} />
              
                {/* Overlay on hover */}
                <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
                style={{ background: 'linear-gradient(to top, rgba(15,34,64,0.85) 0%, transparent 60%)' }}>
                
                  <div className="p-4">
                    <p className="text-xs text-white opacity-90">Click to read bio</p>
                  </div>
                </div>
              </div>

              {/* Name & Title */}
              <div>
                <h3 className="font-bold text-base" style={{ color: '#1a2744' }}>
                  {member.name}
                  {member.credential &&
                <span className="font-normal" style={{ color: '#4060a1' }}>, {member.credential}</span>
                }
                </h3>
                <p className="text-sm mt-0.5" style={{ color: '#666' }}>{member.title}</p>
              </div>

              {/* Bio (expandable) */}
              {activeIndex === i &&
            <div
              className="mt-4 p-4 border-l-2 text-sm leading-relaxed"
              style={{ borderColor: '#c9a84c', color: '#444', backgroundColor: '#f5f6f8' }}>
              
                  {member.bio}
                </div>
            }
            </div>
          )}
        </div>
      </div>
    </section>);

}